module.exports = __webpack_public_path__ + "img/symbol_11.5dbc530f.png";